import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	notifications: [],
};

const myNotificationSlice = createSlice({
	name: 'notifications',
	initialState: initialState,
	reducers: {
		setNotifications: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setNotifications, reset } = myNotificationSlice.actions;

export default myNotificationSlice.reducer;